const weekday = ['dim','lun','mar','mer','jeu','ven','sam'];

export const tooltipCallbacks = {
  title: (items) => {
    const d = new Date(items[0].parsed.x);
    return weekday[d.getUTCDay()] + ' ' + String(d.getUTCHours()).padStart(2, '0') + 'h';
  }
};

/**
 * Config de l'axe x partagée entre tous les graphiques.
 * Axe linéaire en millisecondes (timestamps UTC), espacement proportionnel au temps réel.
 * Le pas des graduations s'adapte à la durée totale de la série.
 *
 * @param {Date[]} times
 */
export function xAxisConfig(times) {
  if (times.length < 2) return { type: 'linear' };
  const t0 = times[0].getTime();
  const t1 = times[times.length - 1].getTime();
  const rangeH = (t1 - t0) / 3_600_000;
  const stepH = rangeH <= 48 ? 3 : rangeH <= 120 ? 6 : 12;
  return {
    type: 'linear',
    min: t0,
    max: t1,
    ticks: {
      stepSize: stepH * 3_600_000,
      callback: (ms) => {
        const d = new Date(ms);
        return weekday[d.getUTCDay()] + ' ' + String(d.getUTCHours()).padStart(2, '0') + 'h';
      },
    },
  };
}

export function enableTouchPan(chart) {
  chart.canvas.style.touchAction = 'none';
}

/**
 * Ajoute des lignes verticales aux minuits dans le tableau d'annotations Chart.js.
 *
 * @param {Date[]} times - timestamps de la série
 * @param {object[]} ann - tableau d'annotations à compléter
 */
export default function def_day_lines(times, ann) {
  for (let i = 1; i < times.length; i++) {
    const prevDay = Math.floor(times[i - 1].getTime() / 86_400_000);
    const currDay = Math.floor(times[i].getTime() / 86_400_000);
    if (currDay !== prevDay) {
      ann.push({
        type: 'line',
        borderColor: 'black',
        borderWidth: 1,
        scaleID: 'x',
        value: currDay * 86_400_000,
      });
    }
  }
}
